<div class="field-checkbox">
  @if (!props.readonly && formControl.enabled) {
    <app-button
      [icon]="props.icon"
      [label]="props.btnLabel"
      type="button"
      (onClick)="props.onClick(field)"
      [class]="props.class"
      [ariaLabel]="props.btnLabel"
    ></app-button>
  }
</div>
